import { create } from "domain";
import { GET, POST, PUT } from "./_config";

export const generalTermsListApi = async (query?: string) =>
  await GET(`/general-terms?${query || ""}`, true);

export const getAllGeneralTermsApi = async () =>
  await GET(`/general-terms/list`, true);

export const createGeneralTermsApi = async (body: any) =>
  await POST(`/general-terms`, body, true);

export const createManyGeneralTermsApi = async (body: any) =>
  await POST(`/general-terms/create-many`, body, true);

export const getGeneralTermsByIdApi = async (termId: string) =>
  await GET(`/general-terms/id/${termId}`, true);

export const updateGeneralTermsApi = async (termId: string, body: any) =>
  await PUT(`/general-terms?id=${termId}`, body, true);

export const getAllGeneralTermsByProductIdApi = async (query?: string) =>
  await GET(`/general-terms/product?${query || ""}`, true);

const GeneralTermsService = {
  generalTermsListApi,
  getAllGeneralTermsApi,
  createGeneralTermsApi,
  createManyGeneralTermsApi,
  getGeneralTermsByIdApi,
  updateGeneralTermsApi,
  getAllGeneralTermsByProductIdApi,
};

export default GeneralTermsService;
